<app-loading *ngIf="loadingAccounts|| loadingCost || loadingProvider"></app-loading>

<p #boxScroll class="title-page">
    Importación de planilla de sueldos
    <a mat-flat-button>
        <mat-icon class="btn-show-dad btn">add</mat-icon>
    </a>
</p>

<!-- 
    <div class="demo-button-container">
        <button mat-raised-button (click)="addData()" class="demo-button">
            Add data
        </button>
        <button mat-raised-button [disabled]="!dataToDisplay.length" (click)="removeData()" class="demo-button">
            Remove data
        </button>
    </div> 
-->

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- CUIL Column -->
    <ng-container matColumnDef="cuil">
        <th mat-header-cell *matHeaderCellDef>CUIL</th>
        <td mat-cell *matCellDef="let element">{{element.cuil}}</td>
    </ng-container>

    <!-- Fullname Column -->
    <ng-container matColumnDef="fullname">
        <th mat-header-cell *matHeaderCellDef>Apellido y Nombre</th>
        <td mat-cell *matCellDef="let element">{{element.fullname}}</td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Tipo de moneda</th>
        <td mat-cell *matCellDef="let element">{{element.type}}</td>
    </ng-container>

    <!-- Price Column -->
    <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Costo Total</th>
        <td mat-cell *matCellDef="let element">{{element.price | number}}</td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Fecha de pago</th>
        <td mat-cell *matCellDef="let element">{{element.date | date: 'dd/MM/yyyy'}}</td>
    </ng-container>

    <!-- Costs Column -->
    <ng-container matColumnDef="costs">
        <th mat-header-cell *matHeaderCellDef>Centro de Costos</th>
        <td mat-cell *matCellDef="let element">{{element.costs}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div class="content-btns" *ngIf="salaries ? salaries.length > 0 : false">
    <button (click)="uploadFile()" mat-raised-button class="blue" color="primary">
        Guardar
    </button>
    <button (click)="cancelUpload()" mat-raised-button class="red btn-show-dad">
        <span class="btn-show-dad">Cancelar</span>
    </button>
</div>

<app-drag-drop type='salaries'></app-drag-drop>